export const breadcrumbItems = [
  {
    key: 'brand',
    label: 'langkey.breadcrumb-brand',
    to: 'brand',
  },
  {
    key: 'tpmsServiceKits',
    label: 'TPMS Service Kits',
  },
];